export default "__VITE_ASSET__Ho_qhBEC__"